require('./RATestNavigation.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

const RATestNavigation = node => {
    return <ul className="navigation">{node.children.map(child => child)}</ul>;
};

RATestNavigation.propTypes = {
    node: PropTypes.any,
};

module.exports = RATestNavigation;
